import { useLocation } from "react-router-dom";
import { useUser } from "../context/UserContext";

export const useAuth = () => {
  const location = useLocation();
  const { user, loading } = useUser();
  const role = user?.role || null;
  const redirectionUrl = `/login`;
  const isLoginPage = location.pathname === redirectionUrl;

  return { role, loading, redirectionUrl, isLoginPage };
};
